<template lang="pug">
  div.checkout-restaurant
    div.checkout-restaurant__inner(v-if="shipment")
      CheckoutIconDelivery(v-if="'delivery' === shipment.name")
      CheckoutIconPickup(v-if="'pickup' === shipment.name")
      div
        p.checkout-restaurant__shipment-type(v-if="'delivery' === shipment.name") {{ shipment.title }} từ
        p.checkout-restaurant__shipment-type.pickup(v-if="'pickup' === shipment.name") Nhận hàng pickup tại
        p.checkout-restaurant__shipment-name {{ restaurant.pos.Pos_Name }}
        p.checkout-restaurant__shipment-address {{ restaurant.pos.Pos_Address }}

</template>
<script>
  import {mapGetters,mapState} from 'vuex';
  import CheckoutIconDelivery from "./CheckoutIconDelivery";
  import CheckoutIconPickup from "./CheckoutIconPickup";

  export default {
    name: 'CheckoutRestaurant',
    components: {CheckoutIconDelivery,CheckoutIconPickup},
    computed: {
      ...mapGetters({
        'shipment': 'shipments/currentShipmentType',
        'restaurant': 'restaurants/currentRestaurantPos',
      })
    },
    data () {
      return {}
    },
    methods: {},
  }
</script>



// WEBPACK FOOTER //
// src/components/CheckoutRestaurant.vue